import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { WishListComponent } from '@spartacus/cart/wish-list/components';
import { PageMetaService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { CustomWishlistService } from './facade/custom-wishlist.service';

@Component({
  selector: 'app-custom-wishlist',
  templateUrl: './custom-wishlist.component.html',
  styleUrls: ['./custom-wishlist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomWishlistComponent extends WishListComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  pageTitle: string;
  pageDescription: string;
  wishListState$ = this.wishListService.getAccountWishList();

  constructor(
    protected wishListService: CustomWishlistService,
    protected pageMetaService: PageMetaService,
  ) {
    super(wishListService);
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageMetaService.getMeta().subscribe(
        data => {
          this.pageTitle = data.title;
          this.pageDescription = data.description;
        },
      ),
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
